
const ContactHero = () => {
  return (
    <section className="relative min-h-[400px] lg:min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/6581e9cf24778fba9486e1fef2feff01.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-primary/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 lg:px-16 max-w-4xl mx-auto">
        <h1 className="text-3xl lg:text-4xl font-bold font-serif mb-4">
          联系合作
        </h1>
        <p className="text-lg lg:text-xl mb-6 text-gray-200">
          携手马帮瑞贡，共创茶业未来
        </p>
        <p className="text-base text-gray-300 max-w-2xl mx-auto leading-relaxed">
          传承三百年马帮精神，我们诚邀各界伙伴共同发展。无论是产品合作、渠道拓展，还是文化交流，马帮瑞贡都将以最专业的态度与您携手前行。
        </p>
      </div>
    </section>
  );
};

export default ContactHero;